module.exports = __webpack_public_path__ + "static/abilia-extraimg2-min-2e9ff4cb1ae0268efc850986d92907ed.png";